export const SERVICE_GROUP = 'Service Group'
